__webpack_require__.p = "//asset-preprod.nykaa.com/dstatic/";